import { OpenAPI } from "~/api-generated/core/OpenAPI";

export default defineNuxtPlugin((context) => {
    const config = useRuntimeConfig();
    OpenAPI.BASE = config.public.apiRootUrl;
})
